module.exports = (User, $scope, $uibModalInstance, metadata, title) ->
  $scope.User = User
  $scope.metadata = metadata
  $scope.title = title or "Report metadata"

  $scope.close = ->
    $uibModalInstance.dismiss("close")
